import { useMutation, useQueryClient } from "@tanstack/vue-query";
import TemplateFolder from "@/services/template/template-folder";
import type { EditTemplateFolder } from "@/dtos/TemplateFolder.dto";

export function useUpdateTemplateFolder() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: EditTemplateFolder) => {
      const response = await TemplateFolder.editTemplateFolder(data);

      if (response.data.status) {
        return response.data.data;
      }

      throw new Error(response.data.msg || "Failed to update template folder");
    },
    onSuccess: () => {
      // Invalidate template folders query to refetch
      queryClient.invalidateQueries({ queryKey: ["templateFolders"] });
    },
  });
}
